import loadingTemplate from '~plugins/loading/LoadingTemplate.vue'
import fullScreenLoadingTemplate from '~plugins/loading/FullScreenLoadingTemplate.vue'
import dialogLoadingTemplate from '~plugins/loading/DialogLoadingTemplate.vue'
import { i18n } from '~src/i18n'
import Store from '~store/store'
import _ from 'lodash'
import { getVuetifyInstance } from '../vuetify'

export default {
  install(Vue) {
    Vue.prototype.$startLoading = loaderMessage => {
      Store.dispatch('startLoading', loaderMessage)
    }

    Vue.prototype.$endLoading = loaderMessage => {
      Store.dispatch('endLoading', loaderMessage)
    }

    Vue.prototype.$isLoading = loaderMessage => {
      return Store.getters.isLoading(loaderMessage)
    }

    Vue.prototype.$anyLoading = () => {
      return Store.getters.anyLoading
    }

    Vue.component('RegLoading', loadingTemplate)
    Vue.component('RegFullLoading', fullScreenLoadingTemplate)
    Vue.component('RegDialogLoading', dialogLoadingTemplate)

    const LoadingDialogConstructor = Vue.extend(dialogLoadingTemplate)
    const instances = {}

    Vue.loadingDialog = Vue.prototype.$loadingDialog = (data, instanceName = 'default') => {
      const propsData = {
        ...data,
        when: true,
        modal: true
      }

      if (instances[instanceName]) {
        _.assign(instances[instanceName], propsData)
        return instances[instanceName]
      }

      const vuetify = getVuetifyInstance()

      instances[instanceName] = new LoadingDialogConstructor({
        i18n,
        vuetify,
        propsData
      })
      instances[instanceName].$mount()

      instances[instanceName].$on('close', payload => {
        instances[instanceName].$destroy()
        if (instances[instanceName].$el && instances[instanceName].$el.parentNode) {
          instances[instanceName].$el.parentNode.removeChild(instances[instanceName].$el)
        }
        instances[instanceName] = null
      })

      document.body.appendChild(instances[instanceName].$el)

      return instances[instanceName]
    }

    Vue.closeLoadingDialog = Vue.prototype.$closeLoadingDialog = (instanceName = 'default') => {
      if (instances[instanceName]) {
        instances[instanceName].$destroy()
        if (instances[instanceName].$el && instances[instanceName].$el.parentNode) {
          instances[instanceName].$el.parentNode.removeChild(instances[instanceName].$el)
        }
        instances[instanceName] = null
      }
    }
  }
}
